export default __webpack_public_path__ + "static/media/help.57120686.svg";